import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5927527c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "sel-main"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 个人姓名 ");

const _hoisted_4 = ["src"];

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 年龄 ");

const _hoisted_6 = ["src"];

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 性别 ");

const _hoisted_8 = ["src"];

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 手机号码 ");

const _hoisted_10 = ["src"];

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 职业 ");

const _hoisted_12 = ["src"];

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 身高 ");

const _hoisted_14 = ["src"];

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 体重 ");

const _hoisted_16 = ["src"];

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 简介 ");

const _hoisted_18 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_title = _resolveComponent("top-title");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_top_title, {
    onBack: $setup.back,
    title: "用户基本信息"
  }, null, 8, ["onBack"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[0] || (_cache[0] = $event => $setup.router.push({
      'name': 'CollectUserName'
    }))
  }, [_hoisted_3, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_4)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[1] || (_cache[1] = $event => $setup.router.push({
      'name': 'CollectUserAge'
    }))
  }, [_hoisted_5, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_6)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[2] || (_cache[2] = $event => $setup.router.push({
      'name': 'CollectUserSex'
    }))
  }, [_hoisted_7, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_8)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[3] || (_cache[3] = $event => $setup.router.push({
      'name': 'CollectUserPhone'
    }))
  }, [_hoisted_9, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_10)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[4] || (_cache[4] = $event => $setup.router.push({
      'name': 'CollectUserJob'
    }))
  }, [_hoisted_11, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_12)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[5] || (_cache[5] = $event => $setup.router.push({
      'name': 'CollectUserHeight'
    }))
  }, [_hoisted_13, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_14)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[6] || (_cache[6] = $event => $setup.router.push({
      'name': 'CollectUserWeight'
    }))
  }, [_hoisted_15, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_16)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[7] || (_cache[7] = $event => $setup.router.push({
      'name': 'CollectUserDesc'
    }))
  }, [_hoisted_17, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_18)])])]);
}